<template>
  <div class="h-100 p-5 bg-light border rounded-3 text-center">
    <img src="../assets/logo.png" class="img-fluid w-50" alt="" />
    <h3>Welcome to the Number Interrogation Tool (NIT)</h3>
    <p>
      Enter a number in the search field and press search to bring back
      information regarding that number.
    </p>
    <div class="row justify-content-center">
      <div class="col-sm-10 col-md-10 col-lg-6">
        <Search 
          @search="numberSearch"
          :min="10" 
          :max="11"
          placeholder="Search by number"
          description="Telephone" />
      </div>
      <div class="col-sm-10 col-md-10 col-lg-6">
        <Search
          @search="numberByAccountSearch"
          :min="1"
          :max="6"
          placeholder="Search by account id"
          description="Account" />
      </div>
      <div v-if="numberList">
        <NumberList
          :numbers="numberList"
          :account="accountIdSearch"
          @numberUpdated="numberUpdated"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Search from "@/components/Search.vue";
import NumberList from "@/components/NumberList.vue";

export default {
  props: {
    numberList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      accountIdSearch: null,
    };
  },
  methods: {
    numberSearch(number) {
      this.$emit("searchNum", number);
    },
    numberByAccountSearch(accNumber) {
      this.accountIdSearch = accNumber;
      this.$emit("searchAcc", accNumber);
    },
    numberUpdated(number) {
      this.$emit("updated", number);
    },
  },
  components: {
    Search,
    NumberList,
  },
};
</script>

<style></style>
